export default "__VITE_ASSET__Bkr7PuJl__"